export default __webpack_public_path__ + "static/media/PenisJackson.fa728ffe.PNG";